import { SSE } from 'sse.js';
import { replacePathParams, resolveConfig, stringifyValues } from '../utils/index.js';
const decodeAndParse = (data) => JSON.parse(decodeURIComponent(data));
const buildSource = async ({ payload, config, path, method, eventName = 'message', pathParameters, queryParameters, headers, onlyNew, lastId, handler, start, }) => {
    const { baseUrl, headers: configHeaders } = await resolveConfig(config);
    const source = new SSE(baseUrl +
        replacePathParams(path, pathParameters) +
        '?' +
        new URLSearchParams(stringifyValues(queryParameters)).toString(), {
        payload: JSON.stringify(payload),
        headers: { ...configHeaders, ...headers },
        start: false,
        method: (method === null || method === void 0 ? void 0 : method.toUpperCase()) || 'GET',
    });
    source.addEventListener(eventName, async ({ id, data }) => {
        if (onlyNew && lastId && lastId >= id) {
            return;
        }
        lastId = id;
        await handler(decodeAndParse(data));
    });
    if (start) {
        source.stream();
    }
    return source;
};
export const noPayloadEventSource = (config) => (path, method, eventName) => (options) => buildSource({
    payload: undefined,
    config,
    path,
    method,
    eventName,
    ...options,
});
export const payloadEventSource = (config) => (path, method, eventName) => (payload, options) => buildSource({
    payload,
    config,
    path,
    method,
    eventName,
    ...options,
});
